import styled from 'styled-components';

import colors from '@front/common/src/utils/colors';
import background from '@front/common/src/assets/images/membership/paywall/background.png';

import { CLOSE_BUTTON_WRAPPER_HEIGHT } from '@front/web-ui/src/components/close-footer/close-footer';
import { minWidth } from '@front/web-ui/src/styles/mixins';
import StickyBottomWrapper from '@front/web-ui/src/components/sticky-bottom-wrapper/sticky-bottom-wrapper';
import Faq from '@front/web-ui/src/components/faq/faq';

export const MembershipBackground = styled.div`
  background: url('${background}') no-repeat bottom center;
  background-size: cover;
  padding: 70px 20px 40px;
  display: flex;
  flex-direction: column;

  ${minWidth.md`
    padding-left: 75px;
    padding-right: 75px;

    background-image: url('${background}');
  `}
`;

export const StickyContainer = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledStickyBottomWrapper = styled(StickyBottomWrapper)`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  padding: 10px 15px;
`;

export const MembershipFaq = styled(Faq)`
  padding: 0 20px 30px;

  ${minWidth.md`
    padding: 0 75px 75px;
  `}
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  top: -30px;
  margin-bottom: ${-1.5 * CLOSE_BUTTON_WRAPPER_HEIGHT}px;

  ${minWidth.md`
    top: 0;
  `}
`;

export const StyledWhiteSpacerRoundedBorders = styled.div`
  background-color: ${colors.white100};
  margin-top: -30px;
  height: 30px;
  border-radius: 30px 30px 0 0;
`;

export const PriceCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 40px;

  ${minWidth.md`
    padding: 0 75px 40px;
  `}
`;
